import { render, staticRenderFns } from "./Piezas.vue?vue&type=template&id=145fb243&scoped=true"
import script from "./Piezas.vue?vue&type=script&lang=js"
export * from "./Piezas.vue?vue&type=script&lang=js"
import style0 from "./Piezas.vue?vue&type=style&index=0&id=145fb243&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145fb243",
  null
  
)

export default component.exports